import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TanksGridComponent } from './tanks-grid.component';
import {TabModule} from '../../tab/tab.module';
import {DxDataGridModule, DxNumberBoxModule, DxValidationGroupModule} from 'devextreme-angular';
import {GridDefaultModule, GridTitleModule, LevelCalibrationModule} from 'shared';
import {UserDomainsChooserModule} from '../../user-domains/user-domains-chooser/user-domains-chooser.module';
import {IconModule} from '@visurel/iconify-angular';
import {SensorHistoryModule} from '../../sensors/sensor-history/sensor-history.module';
import {SensorHistoryPopupModule} from '../../sensors/sensor-history-popup/sensor-history-popup.module';
import {SensorHistoryChartModule} from '../../sensors/sensor-history-chart/sensor-history-chart.module';
import {SensorHistoryChangesModule} from '../../sensors/sensor-history-changes/sensor-history-changes.module';



@NgModule({
  declarations: [TanksGridComponent],
    imports: [
        CommonModule,
        TabModule,
        DxDataGridModule,
        GridTitleModule,
        GridDefaultModule,
        LevelCalibrationModule,
        UserDomainsChooserModule,
        IconModule,
        SensorHistoryModule,
        SensorHistoryPopupModule,
        SensorHistoryChartModule,
        DxNumberBoxModule,
        DxValidationGroupModule,
        SensorHistoryChangesModule
    ],
  exports: [TanksGridComponent]
})
export class TanksGridModule { }
